export default "__VITE_ASSET__C7iY1wuE__"